import { Store } from 'laco'

const colorState = new Store({
  primary: '#f00',
  secondary: '#6BA314',
  background: '#fff',
  background600: '#fff',
  background700: '#F8F8F8',
  background800: '#eef0f1',
  background900: '#F8F8F8',
  backgroundInverted: '#8E98A2',
  borderColor: '#E7E7E7',
  text: '#000',
  textLight: '#888',
  textOnPrimary: '#fff',
  textPrimary: '#FF0000',
  textInverted: '#ddd',
  activity: '#6BA314',
  alert: '#ff9526',
  device: '#9a6fe8',
  message: '#0275d8',
  archived: '#dc3545'
})
const colorStateDark = new Store({
  primary: '#FF0000',
  secondary: '#6BA314',
  background: '#1b1d24',
  background600: '#23252C',
  background700: '#23252C',
  background800: '#2A2C33',
  background900: '#2E3038',
  backgroundInverted: '#8E98A2',
  borderColor: '#23252C',
  text: '#fff',
  textLight: '#888',
  textOnPrimary: '#fff',
  textPrimary: '#FF0000',
  textInverted: '#666',
  activity: '#6BA314',
  alert: '#ff9526'
})

const layoutStore = new Store({
  maxWidth: '1200px',
  breakpoints: {
    mobile: '800px',
    tablet: '1200px'
  }
})
const styleStore = new Store({
  borderRadius: '8px'
})

let colors = colorState.get()

let layout = layoutStore.get()

let styles = styleStore.get()

colorState.subscribe(() => (colors = colorState.get()))
layoutStore.subscribe(() => (layout = layoutStore.get()))
styleStore.subscribe(() => (styles = styleStore.get()))

export { colorState, layoutStore, styleStore, colors, layout, styles }
